import moment from "moment";
import React, { useEffect, useState } from "react";
import LocationAndExpcept from "../../../../constants/LocationAndExpcept";
import { getAllLocations } from "../../../../utils/ApiCalls/Locations";
import DateAndTimePicker from "../../../DateAndTimePicker";
import {
  checkWebpageSlug
} from "../../../../utils/ApiCalls/WebPages";
import "./app.css";
const PageSEO = ({
  errors,
  setErrors,
  page_type,
  cardData,
  addData,
  page_id,
  setCardData,
  webpage_slug,
}) => {
  const [title, setTitle] = useState("");
  const [active, setActive] = useState(false);
  const [locationOption, setLocationOption] = useState([]);
  const [displayLocation, setDisplayLocation] = useState([]);
  const [valid_from, setValidFrom] = useState("");
  const [valid_to, setValidTo] = useState("");
  const [currentLocation, setCurrentLocation] = useState([]);

  const handleDisplayLocationChange = (selectedOptions) => {
    setCardData((item) => ({
      ...item,
      location: selectedOptions,
    }));
    setDisplayLocation(selectedOptions);
    clearError("location");
  };

  const updateComp0 = (key, value) => {
    setCardData((prev) => {
      const comps = [...(prev.component || [])];
      comps[0] = { ...(comps[0] || {}), [key]: value };
      return { ...prev, component: comps };
    });
  };

  const validate = () => {
    const newErrors = {};

    if (page_type === "vlog_item" && !cardData?.component?.[0]?.brand)
      newErrors.brand = "Please select a brand.";

    if (page_type !== "blog_item" && !cardData?.title?.trim())
      newErrors.title = "English page title is required.";

    if (page_type !== "blog_item" && !cardData?.description?.trim())
      newErrors.description = "English meta description is required.";

    if (
      (page_type === "events_item" || page_type === "blog_item" || page_type === "vlog_item") &&
      (!cardData?.location || cardData.location.length === 0)
    )
      newErrors.location = "Display location is required.";

    if (page_type === "blog_item" && !page_id && !cardData?.title?.trim() && !cardData?.slug?.trim())
      newErrors.slug = "Slug is required when english page title is not provided.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    getOptionLocation();
  }, []);
  const getOptionLocation = async () => {
    let data = await getAllLocations();

    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
    } else {
      setLocationOption(data?.data || []);
    }
  };
  const handlePublish = () => {
    if (!validate()) return;
    addData(true);
  };
  const clearError = (key) => {
    if (errors[key]) {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });
    }
  };

  const handleSlugBlur = async () => {
    if (!cardData?.slug) return;

    const payload = {
      slug: cardData.slug,
    };

    if (cardData?.id) {
      payload.id = cardData.id;
    }

    const response = await checkWebpageSlug(payload);

    if (!response?.success) {
      setErrors((prev) => ({
        ...prev,
        slug: response?.message || "Slug already exists",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        slug: "",
      }));
    }
  };
  return (
    <div className="card">
      {!active && (
        <div className="card-body">
          <div className="row">
            {(page_type === "events_item" || page_type === "destinations") && (
              <div className="col-lg-12 col-md-6 col-sm-6 col-6">
                <div className="sailing_date">
                  <h4 className="sub_title2">Valid Date</h4>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      <div className="fieldrow">
                        <label className="f_label">
                          From <span style={{ color: "red" }}> *</span>
                        </label>

                        <DateAndTimePicker
                          value={cardData?.valid_from || ""}
                          setValue={(e) => {
                            setValidFrom(e);
                            setValidTo("");
                            setCardData((item) => ({
                              ...item,
                              valid_from: e,
                            }));
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      <div className="fieldrow">
                        <label className="f_label">
                          To <span style={{ color: "red" }}> *</span>
                        </label>

                        <DateAndTimePicker
                          value={cardData?.valid_to || ""}
                          setValue={(e) => {
                            setValidTo(e);
                            setCardData((item) => ({
                              ...item,
                              valid_to: e,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {page_type === "vlog_item" && (
              <div className="col-lg-12">
                <div className="fieldrow">
                  <label className="f_label">Brand <span style={{ color: "red" }}>*</span></label>
                  <select
                    className="f_input"
                    value={cardData?.component?.[0]?.brand || ""}
                    onChange={(e) => {
                      updateComp0("brand", e.target.value);
                      clearError("brand");
                    }}
                  >
                    <option value="" disabled>Select Brand</option>
                    <option value="dream_cruise">Dream Cruise</option>
                    <option value="star_cruise">Star Cruise</option>
                  </select>
                  {errors?.brand && (
                    <span className="error-msg">{errors.brand}</span>
                  )}
                </div>
              </div>
            )}

            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">English Page Title{page_type !== "blog_item" && <span style={{ color: "red" }}>*</span>}</label>
                <input
                  className="f_input"
                  type="text"
                  value={cardData?.title}
                  onChange={(e) => {
                    clearError("title");
                    clearError("slug");
                    setCardData((item) => ({
                      ...item,
                      title: e.target.value,
                    }));
                  }}
                />
                {errors?.title && (
                  <span className="error-msg">{errors.title}</span>
                )}
              </div>
            </div>

            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">Simplified Chinese Page Title</label>
                <input
                  className="f_input"
                  type="text"
                  value={cardData?.component?.[0]?.simplified_chinese_page_name || ""}
                  onChange={(e) => updateComp0("simplified_chinese_page_name", e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">Traditional Chinese Page Title</label>
                <input
                  className="f_input"
                  type="text"
                  value={cardData?.component?.[0]?.traditional_chinese_page_name || ""}
                  onChange={(e) => updateComp0("traditional_chinese_page_name", e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">Bahasa Page Title</label>
                <input
                  className="f_input"
                  type="text"
                  value={cardData?.component?.[0]?.bahasa_page_name || ""}
                  onChange={(e) => updateComp0("bahasa_page_name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">English Meta Description{page_type !== "blog_item" && <span style={{ color: "red" }}>*</span>}</label>
                <textarea
                  rows="4"
                  cols="50"
                  className="f_input"
                  type="text"
                  value={cardData?.description}
                  onChange={(e) =>{
                    clearError("description");
                    setCardData((item) => ({
                      ...item,
                      description: e.target.value,
                    }))
                   }
                  }
                />
                {errors?.description && (
                  <span className="error-msg">{errors.description}</span>
                )}
              </div>{" "}
            </div>

            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">Simplified Chinese Meta Description</label>
                <textarea
                  rows="4"
                  cols="50"
                  className="f_input"
                  value={cardData?.component?.[0]?.simplified_chinese_meta_description || ""}
                  onChange={(e) => updateComp0("simplified_chinese_meta_description", e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">Traditional Chinese Meta Description</label>
                <textarea
                  rows="4"
                  cols="50"
                  className="f_input"
                  value={cardData?.component?.[0]?.traditional_chinese_meta_description || ""}
                  onChange={(e) => updateComp0("traditional_chinese_meta_description", e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="fieldrow">
                <label className="f_label">Bahasa Meta Description</label>
                <textarea
                  rows="4"
                  cols="50"
                  className="f_input"
                  value={cardData?.component?.[0]?.bahasa_meta_description || ""}
                  onChange={(e) => updateComp0("bahasa_meta_description", e.target.value)}
                />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="fieldrow">
                <label className="f_label">
                  Page Slug
                  {page_type === "blog_item" && !page_id && !cardData?.title?.trim() && (
                    <span style={{ color: "red" }}> *</span>
                  )}
                </label>
                <input
                  className="f_input"
                  type="text"
                  value={cardData?.slug}
                  onChange={(e) => {
                    clearError("slug");
                    setCardData((item) => ({
                      ...item,
                      slug: e.target.value,
                    }));
                  }}
                  onBlur={handleSlugBlur}
                />
                {errors?.slug && (
                  <span className="error-msg">{errors.slug}</span>
                )}
              </div>{" "}
            </div>

            {(page_type === "blog_item"||page_type === "event_item"||page_type === "vlog_item") &&(!webpage_slug?.includes("mobile"))&& (
              <div className="col-lg-12">
                <div className="fieldrow">
                  <label className="f_label">Page Date</label>
                  <input
                    className="f_input"
                    type="date"
                    min={moment().format("YYYY-MM-DD")}
                    value={
                      cardData?.date &&
                      moment(cardData?.date).format("YYYY-MM-DD")
                    }
                    onChange={(e) => {
                      setCardData((item) => ({
                        ...item,
                        date: moment(e.target.value).format("YYYY-MM-DD"),
                      }));
                    }}
                  />
                </div>
              </div>
            )}
            {(page_type === "events_item" || page_type === "blog_item" || page_type === "vlog_item") && (
              <>
                <LocationAndExpcept
                  displayLocation={cardData.location || []}
                  locationOption={locationOption}
                  nondisplay
                  options={locationOption}
                  locationError={errors?.location}
                  setDisplayLocation={(value) => {
                    setCardData((item) => ({
                      ...item,
                      location: value,
                    }));
                    clearError("location");
                  }}
                  handleDisplayLocationChange={handleDisplayLocationChange}
                />
                {errors?.location && (
                  <div className="col-lg-12">
                    <span className="error-msg">{errors.location}</span>
                  </div>
                )}
              </>
            )}

            {!cardData?.id && webpage_slug && (
              <div className="row">
                <div className="col-lg-4">
                  <div className="fieldrow">
                    <label className="f_label">English Menu Title </label>
                    <input
                      className="f_input"
                      type="text"
                      value={cardData?.menuName}
                      onChange={(e) =>
                        setCardData((item) => ({
                          ...item,
                          menuName: e.target.value,
                        }))
                      }
                    />
                  </div>{" "}
                </div>
                <div className="col-lg-4">
                  <div className="fieldrow">
                    <label className="f_label">
                      Simplified Menu Chinese Title{" "}
                    </label>
                    <input
                      className="f_input"
                      type="text"
                      value={cardData?.simplifiedChineseMenuName}
                      onChange={(e) =>
                        setCardData((item) => ({
                          ...item,
                          simplifiedChineseMenuName: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="fieldrow">
                    <label className="f_label">
                      Traditional Chinese Page Title
                    </label>
                    <input
                      className="f_input"
                      type="text"
                      value={cardData?.traditionalChineseMenuName}
                      onChange={(e) =>
                        setCardData((item) => ({
                          ...item,
                          traditionalChineseMenuName: e.target.value,
                        }))
                      }
                    />
                  </div>{" "}
                </div>
              </div>
            )}
          </div>
          {page_id && (
            <div className="text-right" style={{ marginBottom: "10px" }}>
              {" "}
              <button
                style={{ background: "green" }}
                onClick={handlePublish}
                className="btn main_submit"
              >
                Publish
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PageSEO;
